// Remembers whether the signed-in account has any self-hosted licenses so the
// admin sidebar can paint the Self-Hosted item on the first frame. The live
// check (GET /licenses) still runs and overwrites this; a cache miss stays
// "unknown" so the shell can reserve the slot instead of inserting it late.

export const LICENSE_NAV_CACHE_KEY = 'nc-self-hosted-nav';

function readStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

// Distinguishes accounts in this browser without storing another copy of the JWT.
function fingerprint(token) {
  let hash = 5381;
  for (let i = 0; i < token.length; i += 1) {
    hash = ((hash * 33) ^ token.charCodeAt(i)) >>> 0;
  }
  return `${token.length}:${hash.toString(16)}`;
}

function currentFingerprint() {
  const token = readStorage('CloudForge-Token');
  return token ? fingerprint(token) : '';
}

// true / false when this token has a stored answer, otherwise null (unknown).
export function readLicenseNavCache() {
  const current = currentFingerprint();
  if (!current) return null;
  const raw = readStorage(LICENSE_NAV_CACHE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.fingerprint !== current) return null;
    if (parsed.hasLicenses === true || parsed.hasLicenses === false) return parsed.hasLicenses;
  } catch {
    /* corrupt entry — treat as unknown */
  }
  return null;
}

export function writeLicenseNavCache(hasLicenses) {
  const current = currentFingerprint();
  if (!current) return;
  try {
    localStorage.setItem(
      LICENSE_NAV_CACHE_KEY,
      JSON.stringify({ fingerprint: current, hasLicenses: Boolean(hasLicenses) }),
    );
  } catch {
    /* private mode or quota — the nav still resolves from the network */
  }
}

export function clearLicenseNavCache() {
  try {
    localStorage.removeItem(LICENSE_NAV_CACHE_KEY);
  } catch {
    /* ignore */
  }
}

// First-paint value for the sidebar. No token means the item stays hidden
// (the shell is about to redirect to login). A token with no stored answer
// is null: still loading.
export function initialLicenseNavVisibility() {
  if (!readStorage('CloudForge-Token')) return false;
  return readLicenseNavCache();
}
